import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3000/api";

const baseApi = axios.create({
    baseURL: BASE_URL,
    headers: {
        "Content-Type": "application/json",
        "Accept": "application/json;multipart/form-data",
    },
});

// ✅ Add request interceptor to include token dynamically
baseApi.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("token");
        if (token) {
            config.headers["Authorization"] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// ✅ Add response interceptor to handle API errors globally
baseApi.interceptors.response.use(
    (response) => response, // Return response if successful
    async (error) => {
        if (error.response) {
            const { status, data } = error.response;

            switch (status) {
                case 401:
                    toast.warn("Session expired. Please log in again.", { position: "top-right" });
                    localStorage.removeItem("authToken");
                    window.location.href = "/login"; // Redirect to login
                    break;
                case 403:
                    toast.error("Access Denied. Contact super admin.", { position: "top-right" });
                    break;
                case 404:
                    toast.error("Requested resource not found.", { position: "top-right" });
                    break;
                case 500:
                    toast.error("Server error. Please try again later.", { position: "top-right" });
                    break;
                default:
                    toast.error(data?.message || "An unexpected error occurred.", { position: "top-right" });
            }
        } else if (error.request) {
            toast.error("No response from server. Check your internet.", { position: "top-right" });
        } else {
            toast.error("Unexpected error occurred.", { position: "top-right" });
        }

        return Promise.reject(error);
    }
);

export default baseApi;
